
interface ErrorMessageProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorMessage({ message = 'An unexpected error occurred.', onRetry }: ErrorMessageProps) {
  return (
    <div
      role="alert"
      style={{
        backgroundColor: '#fdf3f3',
        border: '1px solid #f5c2c2',
        borderRadius: '6px',
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '12px',
        margin: '16px 0',
      }}
    >
      <span style={{ color: '#d32f2f', fontSize: '1.2rem', lineHeight: 1 }}>&#9888;</span>
      <div style={{ flex: 1 }}>
        <p style={{ color: '#d32f2f', margin: 0 }}>{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            style={{
              marginTop: '8px',
              padding: '6px 14px',
              backgroundColor: '#d32f2f',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
